export default "/images/calendar-check.svg?6e111c2f466e41944b086e6d343ace81";